(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exports(
            require('./metric.js'),
            require('./graph.js'),
            require('../../enums/metrics.js')
        );
    } else {
        RivalIQ.metric.validation = exports(
            RivalIQ.metric,
            RivalIQ.metric.graph,
            RivalIQ.enums
        );
    }

    function exports(metricFn, graph, metricEnums) {

        function validTimeAnalysisModes(metric) {
            if (!graph.hasHistory(metric)) {
                return [metricEnums.timeAnalysisMode.MAIN_PERIOD];
            }

            return [
                metricEnums.timeAnalysisMode.DAILY_VALUES,
                metricEnums.timeAnalysisMode.MAIN_PERIOD,
                metricEnums.timeAnalysisMode.COMPARE_PERIOD,
                metricEnums.timeAnalysisMode.DELTA_ABSOLUTE,
                metricEnums.timeAnalysisMode.DELTA_RELATIVE
            ];
        }

        return {
            validTimeAnalysisModes: validTimeAnalysisModes
        };
    }
})();
